// @flow
import * as React from 'react';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { graphql } from 'react-apollo';

import TARGET_BY_STUDENT_ID_CONTAINER_QUERY from '../queries/TargetByStudentIdContainerQuery.gql';
import { selectStudentIdListRecipient, clearSelection } from 'reducers/roleBasedMessagingSearch';

import type {
  TargetByStudentIdContainer as TargetByStudentIdContainerData,
  TargetByStudentIdContainer_organizations,
} from '../../../SplitComposer/queries/__generated__/TargetByStudentIdContainer';

type Props = {
  children: Function,
  schoolUuids: string[],

  // redux dispatchers
  selectStudentIdListRecipient: (recipient: StudentIdListRecipient) => void,
  clearSelection: () => *,

  // graphql data
  data: ReactApolloData<TargetByStudentIdContainerData>,
};

class TargetByStudentIdContainer extends React.Component<Props, void> {
  isLoading = (props: Props): boolean => {
    return props.data.loading || props.data.networkStatus < 7;
  };

  getOrgs = (props: Props): $ReadOnlyArray<?TargetByStudentIdContainer_organizations> | null => {
    return props.data.organizations || null;
  };

  render() {
    return this.props.children({
      loading: this.isLoading(this.props),
      schools: this.getOrgs(this.props),
      selectStudentIdListRecipient: this.props.selectStudentIdListRecipient,
      clearSelection: this.props.clearSelection,
    });
  }
}

const mapDispatchToProps = (dispatch: Function) =>
  bindActionCreators(
    {
      selectStudentIdListRecipient,
      clearSelection,
    },
    dispatch
  );

const withOrgs = graphql(TARGET_BY_STUDENT_ID_CONTAINER_QUERY, {
  options: ({ schoolUuids }) => ({
    variables: {
      uuids: schoolUuids,
    },
  }),
});

export { TargetByStudentIdContainer };

export default compose(
  connect(undefined, mapDispatchToProps),
  withOrgs
)(TargetByStudentIdContainer);
